import Core  from '@/libs/src/core'
import CapsuleComponent from './capsule-line.vue'
export default ()=>{
    const vce = Core.getProvider('VueCustomElement');
    vce.createComponent('capsule-line',CapsuleComponent)
}